// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1hxGX","insightsList":"newBusinessInsightsMenu_insightsList__X0TCF","active":"newBusinessInsightsMenu_active__1fIUB"};